import quote from 'assets/quote-icon.png';

const FullStack = () => {
  return (
    <>
      <section className='whyme-container' id='aboutme' data-aos='fade-left'>
        <div className='whyme-flex'>
          <div className='whyme-align-items'>
            <div className='this-is-end'>
              <div class='stack1d'>
                <div class='content card1d flex-between'>
                  <p>
                    <b
                      className='auto-underline-animation'
                      data-aos='fade-left'
                    >
                      <span id='desktop-prompt'>Hover</span>
                      <span id='mobile-prompt'>Tap</span> me!
                    </b>
                  </p>
                  <p data-aos='fade-left'>
                    Why them when you have a{' '}
                    <span className='anime-grad'>FULL STACK ME</span>
                  </p>
                </div>
                <div class='padding card1d'></div>
                <div class='border card1d'></div>
                <div class='background card1d'></div>
                <div class='box-shadow card1d'></div>
              </div>
            </div>
          </div>
          <div className='aboutme-right padding-left' data-aos='fade-left'>
            <div>
              <h1 className='auto-underline-animation' data-aos='fade-up'>
                Getting to
                <br /> Know Me
              </h1>
              <span>
                <div className='fullstack-graphictick-container'>
                  <img
                    className='fullstack-graphictick'
                    src={quote}
                    alt='double-quotes'
                  />
                </div>
              </span>
              <p>
                <h3
                  className='whitening-cream hover-underline-animation'
                  data-aos='fade-left'
                >
                  "Being a problem solver,
                </h3>
                I thrive on the challenge of building innovative solutions.
              </p>
              <p>
                {' '}
                <h3 className='hover-underline-animation' data-aos='fade-left'>
                  With an unwavering commitment to{' '}
                  <span className='whitening-cream '>security,</span>
                </h3>
                I'm driven to create robust systems that ensure the utmost
                safety for users."
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FullStack;
